module.exports = __webpack_public_path__ + "img/contact-row-red.6dd2dd7d.png";